import templateUrl from "./intl-tel-input.html";
import "./intl-tel-input.scss";

export const intlTelInputComponent = {
  bindings: {
    onChange: "&",
    defaultClass: "@",
    phoneNumberDetails: "<",
    inputPlaceholder: "@",
    isRequired: "@",
  },
  templateUrl,

  controller: class IntlTelInputComponent {
    constructor($parse) {
      "ngInject";
      this.$parse = $parse;
    }
    $onInit() {
      this.countryCodes = [
        { value: "+1", countryCode: "US" },
        { value: "+91", countryCode: "IND" },
      ];
      if (this.phoneNumberDetails) {
        this.phoneNumber = this.phoneNumberDetails.phoneNumber;
        this.phoneCountryCode = this.phoneNumberDetails.phoneCountryCode;
        this.phoneDialCode = this.phoneNumberDetails.phoneDialCode
          ? this.phoneNumberDetails.phoneDialCode
          : this.countryCodes[0].value;
      }
      if (!this.inputPlaceholder) {
        this.inputPlaceholder = "Phone Number (Optional)";
      }
      this._isRequired = this.$parse(this.isRequired || "false")(true);
    }
    onPhoneNumberChange() {
      this.onChange({
        $event: {
          phoneDialCode: this.phoneDialCode,
          phoneNumber: this.phoneNumber,
          phoneCountryCode: this.phoneCountryCode,
        },
      });
    }
    onPhoneDialCodeChange(phoneDialCode) {
      this.onChange({
        $event: {
          phoneDialCode,
          phoneNumber: this.phoneNumber,
          phoneCountryCode: this.phoneCountryCode,
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/intl-tel-input/intl-tel-input.component.js